//import React, { use } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
  Button,
} from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useEffect } from "react";
import hero from "../assets/contact.jpg";
const brown = "#6b4f3b";

/* =========================
   CARD RIUTILIZZABILE
   ========================= */
function InfoCard({
  icon,
  title,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 5,
        height: "100%",
        p: 2,
        border: "1px solid #eee",
        transition: "0.25s",
        flex: "1 1 320px", // 🔥 responsive auto width
        "&:hover": {
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          transform: "translateY(-4px)",
        },
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          {icon}
          <Typography fontWeight="bold">{title}</Typography>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}

/* =========================
   PAGINA CONTATTI
========================= */
export default function Contact() {
  return (
    <>
      {/* HERO */}
      <Box
        sx={{
          py: { xs: 10, md: 14 },
          textAlign: "center",
          bgcolor: "#fafafa",
          backgroundImage: `url(${hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
        }}
      >
        <Typography fontSize={{ xs: 38, md: 64 }} fontWeight="bold">
          Contatti
        </Typography>

        <Typography mt={2}>
          Vieni a trovarci, chiamaci o scrivici. Ti rispondiamo sempre.
        </Typography>
      </Box>

      {/* ================= INFO CARDS (FLEX) ================= */}
      <Container sx={{ py: 10 }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4,
            justifyContent: "center",
          }}
        >
          <InfoCard
            icon={<PersonIcon sx={{ color: brown }} />}
            title="Proprietaria"
          >
            <Typography color="text.secondary">Sonali </Typography>
          </InfoCard>

          <InfoCard icon={<PhoneIcon sx={{ color: brown }} />} title="Telefono">
            <Button href="tel:+393755752929" sx={{ color: brown, p: 0 }}>
              +39 375 575 2929
            </Button>
          </InfoCard>

          <InfoCard icon={<EmailIcon sx={{ color: brown }} />} title="Email">
            <Button
              href="mailto:caffetteriapisabar@gmail.com"
              sx={{ color: brown, p: 0 }}
            >
              caffetteriapisabar@gmail.com
            </Button>
          </InfoCard>

          <InfoCard
            icon={<WhatsAppIcon sx={{ color: "#25D366" }} />}
            title="WhatsApp"
          >
            <Button
              href="https://wa.me/393755752929"
              target="_blank"
              sx={{ color: "#25D366", p: 0, fontWeight: "bold" }}
            >
              Scrivici subito
            </Button>
          </InfoCard>
        </Box>
      </Container>

      {/* ================= ORARI ================= */}
      <Box sx={{ bgcolor: "#fffaf5", py: 10 }}>
        <Container maxWidth="sm">
          <InfoCard
            icon={<AccessTimeIcon sx={{ color: brown }} />}
            title="Orari di apertura"
          >
            <Typography color="text.secondary">
              Lunedì – Venerdì → 9:00 – 17:00
            </Typography>

            <Typography color="text.secondary">
              Sabato – Domenica → 9:00 – 22:00
            </Typography>
          </InfoCard>
        </Container>
      </Box>

      {/* ================= CTA ================= */}
      <Box sx={{ textAlign: "center", py: 14 }}>
        <Typography variant="h4" fontWeight="bold">
          Eventi, meeting o coworking?
        </Typography>

        <Typography mt={2} color="text.secondary" maxWidth={600} mx="auto">
          Per feste private, eventi aziendali o prenotazioni di gruppo,
          contattaci direttamente via telefono o WhatsApp.
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          justifyContent="center"
          mt={5}
        >
          <Button
            variant="contained"
            size="large"
            href="tel:+39 375 575 2929"
            sx={{ bgcolor: brown, borderRadius: 8 }}
          >
            Chiama ora
          </Button>

          <Button
            variant="outlined"
            size="large"
            href="https://wa.me/393755752929"
            sx={{
              borderColor: "#25D366",
              color: "#25D366",
              borderRadius: 8,
            }}
          >
            WhatsApp
          </Button>
        </Stack>
      </Box>

      {/* ================= INDIRIZZO ================= */}
      <Box sx={{ pb: 10 }}>
        <Container>
          <Stack alignItems="center" spacing={2}>
            <LocationOnIcon sx={{ color: brown }} />
            <Typography fontWeight="bold">Crush Café – Treviso</Typography>
            <Typography color="text.secondary">
              VBar Pisa da Ale, Via Pisa, Treviso, Italia
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
function customUseEffect(arg0: () => void, arg1: never[]) {
  throw new Error("Function not implemented.");
}
